import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EmployeeService } from '../../service/employee.service';
import { Cadre } from '../../models/Cadre';
import { UserService } from '../../service/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OnboardingService } from '../../service/onboarding.service';

@Component({
  selector: 'app-cadre-dialog',
  templateUrl: './cadre-dialog.component.html',
  styleUrls: ['./cadre-dialog.component.css']
})
export class CadreDialogComponent implements OnInit {

  title: string;
  message: any;
  cadre: Cadre;
  error: any;
  empCode: number;
  CadreForm: FormGroup;
  cadresList: any[];
  cadrebool: Boolean = false;
  constructor(private toastr: ToastrService, private userService: UserService, public dialogRef: MatDialogRef<CadreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CadreDialog, private _service: EmployeeService, private formBuilder: FormBuilder, private hrSvc: OnboardingService) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }
    ngOnInit() {
      this.cadre = new Cadre();
      this.getCadres();
      this.empCode = this.userService.getEmpCode();
      const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
      this.CadreForm = this.formBuilder.group({
        /*IsDelivery: [null, Validators.required],*/
        CadreName: ['', [Validators.required, Validators.pattern(nonWhitespaceRegExp)]],
      });
    }
    getCadres() {
      this.hrSvc.getCadres().subscribe(
        (data: any) => {
          this.cadresList = data;
        });
    }

  get f() { return this.CadreForm.controls; }
    onConfirm(): void {
      if(!this.CadreForm.invalid) {
        this.cadre.ModifiedBy = this.empCode.toString();
        this.cadresList.forEach(item => {

          //if (item.CadreName.toLowerCase() == this.cadre.CadreName.toLowerCase() && this.cadre.IsDelivery == item.IsDelivery) {
          //    this.cadrebool = true;
          //  }

          if (item.CadreName.toLowerCase() == this.cadre.CadreName.toLowerCase()) {
            this.cadrebool = true;
          }
      });
      if (this.cadrebool == false) {
        this._service.SaveCadre(this.cadre).subscribe(data => {
          this.dialogRef.close(this.cadre);
        }, error => this.error = error)
      }
      else {
        this.toastr.warning("Same cadre exists");
        this.cadre.CadreName = null;
        this.cadrebool = false;
      }

    }
    else {
      return;
    }


  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
export class CadreDialog {

  constructor(public title: string, public message: any) {
  }
}
